import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IState, testFixturesFeatureKey } from './test-fixtures.reducers';

const selectFeature = createFeatureSelector<IState>(testFixturesFeatureKey);

const selectScenarios = createSelector(
	selectFeature,
	(state) => state.scenarios,
);
const selectScenariosLoading = createSelector(
	selectFeature,
	(state) => state.scenariosLoading,
);
const selectScenariosError = createSelector(
	selectFeature,
	(state) => state.scenariosError,
);
const selectScenarioFilter = createSelector(
	selectFeature,
	(state) => state.scenarioFilter,
);

const selectRunningScenarioId = createSelector(
	selectFeature,
	(state) => state.runningScenarioId,
);
const selectRunResult = createSelector(
	selectFeature,
	(state) => state.runResult,
);
const selectRunError = createSelector(selectFeature, (state) => state.runError);

const selectRuns = createSelector(selectFeature, (state) => state.runs);
const selectRunsPagination = createSelector(
	selectFeature,
	(state) => state.runsPagination,
);
const selectRunsLoading = createSelector(
	selectFeature,
	(state) => state.runsLoading,
);
const selectRunsError = createSelector(
	selectFeature,
	(state) => state.runsError,
);

const selectDeletingRunId = createSelector(
	selectFeature,
	(state) => state.deletingRunId,
);
const selectDeleteResult = createSelector(
	selectFeature,
	(state) => state.deleteResult,
);
const selectPurging = createSelector(selectFeature, (state) => state.purging);
const selectPurgeResult = createSelector(
	selectFeature,
	(state) => state.purgeResult,
);

const selectJobRunning = createSelector(
	selectFeature,
	(state) => state.jobRunning,
);
const selectJobResult = createSelector(
	selectFeature,
	(state) => state.jobResult,
);
const selectJobError = createSelector(selectFeature, (state) => state.jobError);

export const TestFixturesSelectors = {
	selectScenarios,
	selectScenariosLoading,
	selectScenariosError,
	selectScenarioFilter,
	selectRunningScenarioId,
	selectRunResult,
	selectRunError,
	selectRuns,
	selectRunsPagination,
	selectRunsLoading,
	selectRunsError,
	selectDeletingRunId,
	selectDeleteResult,
	selectPurging,
	selectPurgeResult,
	selectJobRunning,
	selectJobResult,
	selectJobError,
};
